var hierarchy = {
  compactBox: require('./compact-box'),
  dendrogram: require('./dendrogram'),
  indented: require('./indented'),
  mindmap: require('./mindmap')
};
module.exports = hierarchy;


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 36
// module chunks = 0